import React, { useState, useEffect, createRef } from 'react'

import qrcode from 'qrcode-generator'

function QrCreator() {
  const [qrData, setQrData] = useState('HTTP://PINGPENGUIN.COM')
  const [qrImageData, setQrImageData] = useState<string | null>(null)
  const [redundancyLevel, setRedundancyLevel] = useState('H')
  const qrCodeTagRef = createRef<HTMLDivElement>()
  const moduleCountRef = createRef<HTMLDivElement>()

  function getModeForDataString(dataSting: string) {
    console.log(dataSting)
    if (/^\d+$/.test(dataSting)) {
      console.log("NUMERIC")
      return 'Numeric'
    }
    //  /^[A-Z0-9]+$/
    if (/^[A-Z0-9+$%*+.\/:-]+$/.test(dataSting)) {
      return 'Alphanumeric'
    }
    return 'Byte'
  }

  useEffect(() => {
    console.log(`Level ${redundancyLevel}, data: ${qrData}`)
    const qr = qrcode(0, redundancyLevel as any);
    const mode = getModeForDataString(qrData)
    const padding = 20
    const radius = 4
    const cellsize = 10

    qr.addData(qrData, mode);
    qr.make();

    const modulecount = qr.getModuleCount()
    console.log(`qr code has module coutnt of ${modulecount}`)
    let svg = `<svg height="${modulecount * cellsize + padding + padding + 2}" width="${modulecount * cellsize + padding + padding + 2}">`
    svg += `<rect width="${modulecount * cellsize + 40}" height="${modulecount * cellsize + padding + padding}" stroke="red" stroke-width="1" fill="none" />`
    for (let y = 0; y < modulecount; y++) {
      for (let x = 0; x < modulecount; x++) {
        if (qr.isDark(x, y)) {

          svg += `<circle cx="${x * cellsize + radius + padding + 1}" cy="${y * cellsize + radius + padding + 1}" r="${radius}" stroke="red" stroke-width="1" fill="none" />`
          //      svg+=`<circle cx="${x*10 + 25}" cy="${y*10 + 20}" r="2" stroke="red" stroke-width="1" fill="none" />`
          //      svg+=`<circle cx="${x*10 + 20 } " cy="${y*10 + 25}" r="2" stroke="red" stroke-width="1" fill="none" />`
          //      svg+=`<circle cx="${x*10 + 25}" cy="${y*10 + 25}" r="2" stroke="red" stroke-width="1" fill="none" />`

        }
      }
    }
    svg += "</svg>"
    console.log(svg)
    const version = ((qr.getModuleCount() - 21) / 4) + 1
    const imageData = qr.createSvgTag(4)
    qrCodeTagRef.current!.innerHTML = imageData
    setQrImageData(imageData)
    moduleCountRef.current!.innerHTML = `Version ${version} ${mode}`
  }, [qrData, redundancyLevel, qrCodeTagRef, moduleCountRef])


  const download = () => {
    if (qrImageData) {
      const timestamp = Date.now()
      var element = document.createElement('a')
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(qrImageData))
      element.setAttribute('download', `qrcode-${timestamp}.svg`)
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    }
  }

  const downloadPng = () => {
    if (!qrImageData) return;

    const svgBlob = new Blob([qrImageData], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);

      canvas.toBlob((blob) => {
        if (!blob) return;
        const timestamp = Date.now();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `qrcode-${timestamp}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, 'image/png');
    };

    img.src = url;
  };


  return <div>
    <div className="inner">
      <h1>Generate a QR code</h1>

      <div className={`columns`}>
        <div className={`column left`}>
          <p>URL:</p>
          <input
            type='text'
            value={qrData}
            onChange={(e) => { setQrData(e.target.value) }}
          />
          <p>Redundancy: </p>
          <select value={redundancyLevel}
            onChange={(e) => { setRedundancyLevel(e.target.value) }}
          >
            <option value='L'>L - Low</option>
            <option value='M'>M - Medium </option>
            <option value='Q'>Q - Quartile </option>
            <option value='H'>H - High</option>
          </select>
        </div>
        <div className={`column right`}>
          <div ref={qrCodeTagRef}></div>
          <div ref={moduleCountRef}></div>
          <p>Download:</p>
          {qrImageData && <button onClick={download}>Download SVG</button>}
          {qrImageData && <button onClick={downloadPng}>Download PNG</button>}
          <p> Copy to clipboard:</p>
          {qrImageData && (
            <>
              <button
                onClick={async () => {
                  if (navigator.clipboard && 'write' in navigator.clipboard) {
                    const blob = new Blob([qrImageData], { type: 'image/svg+xml' });
                    const item = new window.ClipboardItem({ 'image/svg+xml': blob });
                    await navigator.clipboard.write([item]);
                  } else {
                    //@ts-ignore
                    await navigator.clipboard.writeText(qrImageData);
                  }
                }}
              >
                Copy SVG
              </button>
              <button
                onClick={async () => {
                  if (navigator.clipboard && 'write' in navigator.clipboard) {
                    // Convert SVG to PNG using a canvas
                    const svg = new Blob([qrImageData], { type: 'image/svg+xml' });
                    const url = URL.createObjectURL(svg);
                    const img = new window.Image();
                    img.onload = async () => {
                      const canvas = document.createElement('canvas');
                      canvas.width = img.width;
                      canvas.height = img.height;
                      const ctx = canvas.getContext('2d');
                      if (ctx) {
                        ctx.drawImage(img, 0, 0);
                        canvas.toBlob(async (blob) => {
                          if (blob) {
                            const item = new window.ClipboardItem({ 'image/png': blob });
                            await navigator.clipboard.write([item]);
                          }
                        }, 'image/png');
                      }
                      URL.revokeObjectURL(url);
                    };
                    img.src = url;
                  } else {
                    //@ts-ignore
                    await navigator.clipboard.writeText(btoa(qrImageData));
                  }
                }}
              >
                Copy PNG
              </button>
            </>
          )}
        </div>
      </div>
    </div>

  </div>
}

export default QrCreator